import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo buscando recetas que no encajan con lo que tenés en casa', 'Lunes a la noche improvisando porque no planificaste nada', 'Siempre las mismas 5 comidas — sin variedad, sin sistema', 'Heladera llena de ingredientes que no sabés cómo combinar', 'Delivery otra vez — $5.000 que podrían haberse evitado', 'El mismo ciclo. El domingo siguiente. Otra vez.'];
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-216">
      <div className="max-w-3xl mx-auto" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-218">
          <h2 className="md:text-4xl font-bold mb-6 text-[25px]" data-id="element-219">
            ¿Cuántos domingos más vas a perder así?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-220">
            Querés comer bien. Querés organizarte. Pero sin un sistema, la
            semana siempre termina igual. <br data-id="element-221" />
            <br data-id="element-222" />
            <span className="text-brand-gold font-semibold" data-id="element-223">
              No es falta de ganas. Es falta de sistema.
            </span>
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-224">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-brand-card p-4 rounded-xl border border-red-900/20" data-id="element-225">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-226" />
              <span className="text-gray-300 text-[15px]" data-id="element-227">{point}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-228">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-gold" data-id="element-229">
            ¿Y si este fuera el último domingo que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}